import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { themeState } from 'styleguide/theme';
import { Footer } from 'components/Footer';
import { observer } from 'mobx-react-lite';
import { View } from 'styleguide/View';
import { UnauthenticatedPaywall } from './UnauthenticatedPaywall';

const MOBILE_BREAKPOINT = 1270;

const Container = styled(View)`
  flex-direction: 'row';
  align-items: center;
  width: 100%;
  overflow-y: scroll;
`;

const Content = styled(View)`
  max-width: 1024px;
  padding: 64px 0;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0 0 64px 0;
    max-width: 360px;
  }
`;

export const PricingScreen = observer(() => {
  return (
    <ThemeProvider theme={themeState.current}>
      <Container>
        <Content>
          <UnauthenticatedPaywall />
          <Footer showPricingLink={true} />
        </Content>
      </Container>
    </ThemeProvider>
  );
});
